/* esm.sh - rxjs@7.8.2/dist/esm/internal/operators/first */
export * from "/*rxjs@7.8.2/esnext/dist/esm/internal/operators/first.mjs";
